module.exports = __webpack_public_path__ + "static/media/42-4.898a26fb.mp3";